import React from 'react';
import block from 'bem-cn-lite';
import {Icon, IconProps} from '@yandex-data-ui/common';

import './RecommendedIcon.scss';

import recommendedIcon from 'icons/fire.svg';

const b = block('RecommendedIcon');

const RecommendedIcon: React.FC<Omit<IconProps, 'data'>> = ({size = 20, className, ...props}) => {
    return <Icon className={b(null, className)} data={recommendedIcon} size={size} {...props} />;
};

export default RecommendedIcon;
